
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/5337f555661671eb499c5bbdb40f9c20.png" 
                alt="Dunn's O.V. OceanView Inn & Sports Pub Logo" 
                className="h-20 w-auto"
              />
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Experience authentic Florida Keys hospitality in Islamorada. Locally owned for 25+ years.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-slate-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/rooms" className="text-sm text-slate-400 hover:text-white transition-colors">Rooms</Link></li>
              <li><Link to="/pub" className="text-sm text-slate-400 hover:text-white transition-colors">The Pub</Link></li>
              <li><Link to="/menu" className="text-sm text-slate-400 hover:text-white transition-colors">Menu</Link></li>
              <li><Link to="/events" className="text-sm text-slate-400 hover:text-white transition-colors">Events</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-blue-400 mt-1"></i>
                <span className="text-sm text-slate-400">84500 Overseas Hwy<br />Islamorada, FL 33036</span>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-blue-400"></i>
                <a href="tel:+13056648052" className="text-sm text-slate-400 hover:text-white transition-colors">(305) 664-8052</a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-mail-line text-blue-400"></i>
                <a href="mailto:resinfo@theocean-view.com" className="text-sm text-slate-400 hover:text-white transition-colors">resinfo@theocean-view.com</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 uppercase tracking-wider">Follow Us</h4>
            <div className="flex space-x-3 mb-6">
              <a
                href="https://www.facebook.com/The-OceanView-Motel-and-Sports-Pub-176655585715394"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://www.instagram.com/oceanview_inn_pub/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
            <a
              href="https://www.toasttab.com/the-ocean-view-84500-overseas-hwy"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              Order Online
            </a>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-slate-400">
            © {currentYear} The Ocean View Inn & Sports Pub. All Rights Reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-slate-400 hover:text-white transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
